import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TextField,
  Grid,
  CardHeader,
  Divider,
  Button,
  Fab,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import SaveIcon from "@material-ui/icons/Save";
import RTL from "../../../../components/RTL";
import supervisor from "./../../../Supervisor";
import Autocomplete from "@material-ui/lab/Autocomplete";
import clsx from "clsx";

import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import FilledInput from "@material-ui/core/FilledInput";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const useStyles = makeStyles((theme) => ({
  
  input: {
    marginTop: theme.spacing(4),
    width: "100%",
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: "100%",
  },
  
  divider: {
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    backgroundColor: "#273c75",
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
}));

const Form = (props) => {
  const { data, id, edit } = props;

  const classes = useStyles();

  const [values, setValues] = React.useState({
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <RTL>
      <Grid justify="center" container>
        <CardHeader title="ثبت پرسنل جدید" />
        <Divider className={classes.divider} variant="fullWidth" />
      </Grid>

      <Grid container justify="space-between">
        <Grid item xs={12} sm={5}>
          <TextField
            className={classes.input}
            label="نام کاربری "
            variant="outlined"
            defaultValue={
              edit
                ? data
                    .filter((data) => data.id == id)
                    .map((filterData) => filterData.Username)
                : ""
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl className={clsx(classes.input)} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              کلمه عبور
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={values.showPassword ? "text" : "password"}
              value={values.password}
              defaultValue={
                edit
                  ? data
                      .filter((data) => data.id == id)
                      .map((filterData) => filterData.Pass)
                  : ""
              }
              onChange={handleChange("password")}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
        </Grid>
      </Grid>


    

     
 
        <Button
          fullWidth
          className={(classes.input, classes.inputBtn)}
          variant="contained"
          color="secondary"
          size="large"
          startIcon={<SaveIcon className={classes.submitButtonIcon} />}
        >
        بروزرسانی
        </Button>
      
    </RTL>
  );
};

export default Form;
